goog.provide('el8.appchart.refpanel.maint');

goog.require('el8.appchart.cqmRefresh');
goog.require('el8.appchart.metrics');
goog.require('el8.appchart.refpanel.maintItems');
goog.require('el8.appchart.refpanel.RefPanelSection');

goog.require('el8.ptdata.ptMaintItems');
goog.require('el8.template.appchart.refpanel.maint');

goog.require('el8.service.tz');
goog.require('el8.shared.util.cqm');
goog.require('el8.shared.util.hmReminder');


el8.appchart.refpanel.maint = (function() {
    var reportOnFirstLoad = el8.appchart.metrics.getChartLoadCallback('maint');
    var dialogs = {};

    function showDialog(title, ruleId) {
        if(dialogs[ruleId]) {
            if(dialogs[ruleId].isOpen()) {
                dialogs[ruleId].bringForward();
                return;
            }
            else {
                dialogs[ruleId].destroy();
            }
        }

        dialogs[ruleId] = el8.appchart.refpanel.maintItems();
        dialogs[ruleId].show({
            'title': title,
            'ruleId': ruleId
        });
    }

    var that = new el8.appchart.refpanel.RefPanelSection({
        initFn: function() {
            that.addContainer($('#maint-container'));
            el8.uiwidget.collapsible({
                container: $('#maint-container'),
                triggerElt : $('#maint-header'),
                statusElt : $('#maint-status')
            });
        },
        dataRenderers: [
            {
                listenFn: function() {
                    var now = el8.appchart.cqmRefresh.getReportingDate();
                    var cqmStatus = el8.appchart.cqmRefresh.cqmStatus;
                    var reminders = el8.shared.util.hmReminder.calculateHMReminders(cqmStatus, now);

                    // render the items
                    $('#maintenance-rule-list').html(
                        el8.template.appchart.refpanel.maint.summary({reminders: reminders})
                    );

                    // clicking on the name should show the dialog
                    $('#maintenance-rule-list').on('click', '.details-trigger',  function() {
                        var obj = $(this);
                        var itemId = obj.data('id');
                        var name = obj.data('name');
                        showDialog(name, itemId);
                    });

                    // action menu
                    $('#maintenance-rule-list').on('click', '.more-actions-trigger',  function(e) {
                        var obj = $(this);
                        var itemId = obj.data('id');
                        var name = obj.data('name');

                        // find the reminder to render the data
                        var reminder = _.find(reminders, function(reminder){ return reminder.maintRuleId === itemId; });
                        var reminderText = (reminder) ? el8.util.string.removeHtmlFromStr(el8.template.appchart.refpanel.maint.reminderText(reminder)) : name;
                        var menu = [
                            {
                                actionText: 'View / Edit Details',
                                actionFn: function() {
                                    showDialog(name, itemId);
                                }
                            },
                            {
                                actionText: 'Export to Note',
                                actionFn: function() {
                                    el8.appchart.mgr.notes.addText(reminderText, 'data');
                                }
                            }
                        ];
                        el8.appchart.refpanel.actionsMenu.display(
                            $(this), null, {top: 17, left: 13}, menu
                        );
                        return false;
                    });

                    reportOnFirstLoad();
                }
            }
        ]
    });

    that.showDialog = showDialog;

    el8.appchart.cqmRefresh.register({
        startCb: function() {
            $('#maint-refpanel-updating-marker').show();
            $('#maint-refpanel-error-marker').hide();
        },
        updateCb: function(url, changed) {
            if (changed) {
                that.render();
            }
        },
        endCb: function() {
            $('#maint-refpanel-updating-marker').hide();
            $('#maint-refpanel-error-marker').hide();
        },
        errorCb: function() {
            $('#maint-refpanel-updating-marker').hide();
            $('#maint-refpanel-error-marker').show();
        }
    });

    return that;

})();
